import { Chip } from "@mui/material";
import { useState } from "react";
import CostPricingPopover from "./CostPricingPopover";

const COST_CONFIG = {
  MARKETING: {
    label: "Marketing",
    color: "#F97316",
  },
  UTILITY: {
    label: "Utilidade",
    color: "#06B6D4",
  },
  authentication: {
    label: "Autenticação",
    color: "#4F46E5",
  },
  free: {
    label: "Gratuito",
    color: "#16A34A",
  },
  consult: {
    label: "Sob consulta",
    color: "#A21CAF",
  },
  UNKNOWN: {
    label: "Desconhecido",
    color: "#64748B",
  },
};

export default function CostPreviewChip({
  channelType,
  costCategory,
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const isFree = channelType === "whatsapp_web";

  const finalConfig = isFree
    ? COST_CONFIG.free
    : COST_CONFIG[costCategory] || COST_CONFIG.consult;

  const handleOpenPopover = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Chip
        size="small"
        label={finalConfig.label}
        onClick={handleOpenPopover}
        variant="outlined"
        sx={{
          cursor: "pointer",
          fontWeight: 700,
          fontSize: "0.72rem",

          // Estado normal
          color: finalConfig.color,
          borderColor: finalConfig.color,
          backgroundColor: `${finalConfig.color}20`,
          transition: "all 0.2s ease-in-out",

          "&:hover": {
            backgroundColor: `${finalConfig.color} !important`,
            borderColor: finalConfig.color,
            boxShadow: `0px 3px 6px ${finalConfig.color}50`,
          },

          "&:hover .MuiChip-label": {
            color: "#fff !important",
          },

          "&.Mui-focusVisible": {
            backgroundColor: finalConfig.color,
          },

          "&.Mui-focusVisible .MuiChip-label": {
            color: "#fff",
          },
        }}
      />

      <CostPricingPopover
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        channelType={channelType}
        category={costCategory}
      />
    </>
  );
}
